import { Component, effect, ElementRef, input, signal, viewChild, inject } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Breadcrumb } from '../../../store/models';
import { Router } from '@angular/router';
import { I18nPipe } from '../../i18n/i18n.pipe';
import { ClickCursorDirective } from '../../directives/click-cursor.directive';

@Component({
  selector: 'gnx-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  animations: [
    trigger('appear', [
      state('inOut', style({ maxWidth: '300px' })),
      transition(':leave', animate(1000, style({ maxWidth: 0, overflow: 'hidden' }))),
      transition(':enter', [style({ maxWidth: 0, overflow: 'hidden' }), animate(1000)]),
    ]),
  ],
  imports: [ClickCursorDirective, I18nPipe],
})
export class BreadcrumbComponent {
  private router = inject(Router);

  private container = viewChild<ElementRef>('container');

  crumbs = input<Breadcrumb[]>([]);

  protected displayCrumbs = signal<Breadcrumb[]>([]);

  private intervalId: ReturnType<typeof setInterval>;

  constructor() {
    effect((onCleanup) => {
      this.displayCrumbs.set([...this.crumbs()]);
      clearInterval(this.intervalId);
      this.intervalId = setInterval(() => this.checkOverflow(), 1000);
      onCleanup(() => clearInterval(this.intervalId));
    });
  }

  onClick(crumb: Breadcrumb) {
    if (crumb.route) {
      this.router.navigate([crumb.route], { queryParams: crumb.queryParams });
    }
    if (crumb.callback) {
      crumb.callback.apply(null, crumb.callbackParams);
    }
  }

  private checkOverflow(): void {
    const el = this.container()?.nativeElement;
    if (!el) {
      return;
    }
    if (el.scrollWidth > el.clientWidth) {
      this.displayCrumbs.update((crumbs) => crumbs.slice(1));
    } else {
      clearInterval(this.intervalId);
    }
  }
}
